// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Avendra: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22">
            <g fill="none" fillRule="evenodd">
                <path
                    fill="#008fdc"
                    fillRule="nonzero"
                    d="M14.078 2S5.341 10.673 4 20c0 0 3.513-5.435 10.041-6.27 0 0-3.153-1.4-6.156.039 0 0 .77-3.392 4.17-7.093 0 0 .062 5.808 4.294 8.686 0 0 .596-.078 1.651.18 0 0-5.274-4.819-3.922-13.542"
                />
            </g>
        </svg>
    );
};

export default React.memo(Avendra);
